import { Product } from './Product';
import { TextureMaterial } from './TextureMaterial';

export interface CladdingProduct extends Product {
  imageUrl: string;
  textureMaterial?: TextureMaterial;
}
